import { CartUpdateEvent } from '@theme/events';

// IKORA – botones de oferta dentro del carrito (segundo par / pack con líquido)
if (!window.__ikoraCartOffers) {
  window.__ikoraCartOffers = true;

  // Selector "cuidado completo": pasa la opción elegida al botón negro
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'ikora-care') return;
    const submit = input.closest('.ikora-care')?.querySelector('.ikora-care__submit');
    if (submit instanceof HTMLElement) submit.dataset.ikoraUpdates = input.value;
  });

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-ikora-updates]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();
    button.disabled = true;

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')]
          .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
          .filter(Boolean)
      ),
    ];

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: JSON.parse(button.dataset.ikoraUpdates || '{}'),
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || 'No se pudo actualizar el carrito');

      if (!sectionIds.length || !cart.sections) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(
        new CartUpdateEvent(cart, 'ikora-cart-offers', {
          itemCount: cart.item_count,
          source: 'ikora-cart-offers',
          sections: cart.sections,
        })
      );
    } catch (error) {
      console.error('[IKORA ofertas carrito]', error);
      button.disabled = false;
    }
  });
}
